import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { ConciergeErrorResponse } from 'src/api/concierge';

import { BookingsEndpoints, getBookingsSummary, BookingsSummary } from '../api';

type QueryConfig = UseQueryOptions<BookingsSummary, AxiosError<ConciergeErrorResponse>>;

export const useGetBookingsSummary = (config: QueryConfig = {}) => {
    const query = useQuery<BookingsSummary, AxiosError<ConciergeErrorResponse>>({
        queryKey: [BookingsEndpoints.getBookingsSummary],
        queryFn: getBookingsSummary,
        ...config,
    });

    return query;
};
